import { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { ArrowRight, CheckCircle, Loader2 } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NewsletterForm = ({ variant = 'default' }) => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle, loading, success, error
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setStatus('loading');
    try {
      await axios.post(`${API}/newsletter`, { email });
      setStatus('success');
      setEmail('');
    } catch (error) {
      setStatus('error');
      setErrorMessage('Something went wrong. Please try again.');
    }
  };

  if (status === 'success') {
    return (
      <div className="flex items-center gap-2 text-[#27AE60]" data-testid="newsletter-success">
        <CheckCircle size={20} />
        <span className={variant === 'footer' ? 'text-sm' : 'text-base'}>You're subscribed!</span>
      </div>
    );
  }

  const isFooter = variant === 'footer';

  return (
    <form onSubmit={handleSubmit} className="space-y-3" data-testid="newsletter-form">
      <div className={`flex ${isFooter ? 'flex-col sm:flex-row' : 'flex-col sm:flex-row'} gap-2`}>
        <Input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className={`${
            isFooter
              ? 'bg-slate-700 border-slate-600 text-white placeholder:text-slate-400 focus:border-[#3498DB]'
              : 'bg-white border-slate-200 focus:border-[#3498DB]'
          }`}
          data-testid="newsletter-email-input"
          required
        />
        <Button
          type="submit"
          disabled={status === 'loading'}
          className={`${
            isFooter
              ? 'bg-[#3498DB] hover:bg-[#2980B9] text-white'
              : 'bg-[#3498DB] hover:bg-[#2980B9] text-white shadow-[0_4px_14px_0_rgba(52,152,219,0.39)]'
          }`}
          data-testid="newsletter-submit"
        >
          {status === 'loading' ? (
            <Loader2 className="animate-spin" size={18} />
          ) : (
            <>
              Subscribe
              <ArrowRight size={16} className="ml-1" />
            </>
          )}
        </Button>
      </div>
      {status === 'error' && (
        <p className="text-red-500 text-sm" data-testid="newsletter-error">{errorMessage}</p>
      )}
    </form>
  );
};
